var exports = {
  "zr": "x804f0401--6ca1dc--root",
  "R_": "x804f0401--6ca1dc--heading",
  "Ge": "x804f0401--6ca1dc--rows",
  "nM": "x804f0401--6ca1dc--row",
  "u1": "x804f0401--6ca1dc--text-box",
  "Wk": "x804f0401--6ca1dc--row-description",
  "$K": "x804f0401--6ca1dc--row-icon",
};

module.exports = exports;
